import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import Chart from './Chart'
import PeriodDescription from '../../_shared/PeriodDescription'
import PerspectiveDropdown from '../../_shared/PerspectiveDropdown'
import ServiceOrdersByStatusLoader from './_load/ServiceOrdersByStatusLoader'
import WidgetWrapper from '../../WidgetWrapper'

const ServiceOrdersByStatusWidget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between">
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
        <PerspectiveDropdown />
      </Grid>

      <ServiceOrdersByStatusLoader>
        <Chart widget={widget} />
      </ServiceOrdersByStatusLoader>
    </WidgetWrapper>
  )
}

export default ServiceOrdersByStatusWidget
